import React, { useState } from 'react';

import { TranslationLanguageSelector } from './translation-language-selector';

import { UiButton } from '../../../ui/ui-button';
import { UiDialog } from '../../../ui/ui-dialog';

import {
  getCachedSelectedTranslationLanguage,
  setCachedSelectedTranslationLanguage,
} from '../util/translation-language-selection';

type InputProps = {
  /**
   * Callback to invoke on dialog close
   */
  closeDialogClickCallback: () => void;
};

export const TranslationLanguageSelectorDialog = ({ closeDialogClickCallback }: InputProps) => {
  const [selectedLanguage, setSelectedLanguage] = useState<string>(
    getCachedSelectedTranslationLanguage() || 'es',
  );

  const onLanguageSelectionChange = (value: string) => {
    setSelectedLanguage(value);
  };

  const handleTranslateClick = () => {
    setCachedSelectedTranslationLanguage(selectedLanguage);
    closeDialogClickCallback();
  };

  return (
    <UiDialog
      title="Select language"
      size="sm"
      onClose={closeDialogClickCallback}
      dataCy="translation-language-selector-dialog"
    >
      <UiDialog.Content>
        <div>Please select a language to translate your message into.</div>
        <TranslationLanguageSelector
          value={selectedLanguage}
          onChange={onLanguageSelectionChange}
        />
      </UiDialog.Content>
      <UiDialog.Actions>
        <UiButton
          onClick={closeDialogClickCallback}
          variant="dismiss"
          dataCy="cancel-language-selection"
        >
          Cancel
        </UiButton>
        <UiButton
          onClick={handleTranslateClick}
          disabled={!selectedLanguage}
          dataCy="save-language-selection"
        >
          Translate
        </UiButton>
      </UiDialog.Actions>
    </UiDialog>
  );
};
